import { withStyles } from "@material-ui/core/styles";
import CustomButton from "./Button";
import React from "react";

const StyledButton = withStyles((theme) => ({
  root: {
    // textTransform: 'none',
    backgroundColor: "#8FC600 !important",
  },
}))((props) => <CustomButton {...props} />);

export default StyledButton;
